import { cadastro_causa_abandono } from "./cadastro-causa-abandono";

const tabelas_auxiliares = [cadastro_causa_abandono];

export { tabelas_auxiliares };
